<template>
  <div class="timeline">
    <div class="timeline-item" v-for="(item, i) in items" :key="i">
      <ul>
        {{item.title}}
        <li v-for="(subitem, j) in item.subitems" :key="j">
          <router-link :to="subitem.path">{{ subitem.title }}</router-link>
        </li>
      </ul>

      <svg class="circle" height="10" width="10" viewBox="0 0 10 10">
        <circle cx="5" cy="5" r="5" stroke="none" stroke-width="0" fill="black" />
      </svg>
    </div>
    <svg class="triangle" height="10" width="10" viewBox="0 0 10 10">
      <path d="M0 0 L5 10 L10 0 Z" />
    </svg>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      items: [
        {
          title: "Mach Mit, Etappe 1",
          subitems: [
            { title: "Interaktive Karte", path: "/machmit/karte" },
            {
              title: "Auswertung",
              path: "/machmit/auswertung"
            }
          ]
        },
        {
          title: "Etappe 2",
          subitems: [{ title: "Online Umfrage", path: "/machmit/umfrage" }]
        },
        {
          title: "Etappe 3",
          subitems: [
            { title: "Parklet Ideenbaum", path: "/machmit/ideenbaum" },
            { title: "Kinderstadt", path: "/machmit/kinderstadt" }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.timeline {
  position: relative;
  .triangle {
    position: absolute;
    left: -3.5px;
    fill: #b8c2d6;
  }
  .timeline-item {
    padding: 10px;
    padding-top: 0;
    position: relative;
    border-left: 2px solid #b8c2d6;
    .circle {
      position: absolute;
      top: 0;
      left: -5.5px;

      circle {
        fill: #b8c2d6;
      }
    }
  }
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    margin: 5px 10px;
  }
}
a {
  text-transform: uppercase;
  &:hover {
    font-weight: inherit;
    text-decoration: underline;
  }
}
</style>